module.exports = __webpack_public_path__ + "static/img/4.70b0c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/4.png
// module id = cunR
// module chunks = 1